export const TRANSACTION_STORE_NAME = 'Transactions'
